export interface IAgrupamentoAtividade {
  id: number;
  nome: string;
  descricao?: string;
  icone?: string;
}

export const agrupamentoNaoAgrupar: IAgrupamentoAtividade = {
  id: 1,
  nome: 'Não agrupar',
  descricao: 'Lista as atividades em sequência única',
  icone: 'fas fa-list',
};
export const agrupamentoPorPrazo: IAgrupamentoAtividade = {
  id: 2,
  nome: 'Prazo',
  descricao: 'Agrupa por situação do prazo',
  icone: 'fas fa-clock',
};
export const agrupamentoPorResponsavel: IAgrupamentoAtividade = {
  id: 3,
  nome: 'Responsável',
  descricao: 'Agrupa pelo responsável da atividade',
  icone: 'fas fa-user',
};

export const AGRUPAMENTOS_ATIVIDADE: IAgrupamentoAtividade[] = [
  agrupamentoNaoAgrupar,
  agrupamentoPorPrazo,
  agrupamentoPorResponsavel,
];

export const AGRUPAMENTOS_ATIVIDADE_NAO_GESTORES: IAgrupamentoAtividade[] = [
  agrupamentoNaoAgrupar,
  agrupamentoPorPrazo,
];
